<!-- 其他操作日志 -->
<template>
  <div class="tableShow">
    <Table
      ref="table"
      :loadObj="{}"
      :dict="[]"
      :option="{}"
      :colObj="{
        opId: '20022',
        col: [],
        query:{
          ZGDWID:userInfo.company_id
        },
        toDetailClick,
      }"
    >
    </Table>
    <!-- 信息明细弹出框 -->
    <el-dialog :visible.sync="addDialog" :append-to-body="true" title="信息明细" @closed="closed" width="90%" top="15vh" :close-on-click-modal="false" v-dialogdrag>
      <!-- 表格 -->
      <avue-crud :data="tableData" :option="option"></avue-crud>

      <!-- 分页 -->
      <div class="ux-page">
        <footer>
          <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page="page.currentPage" :page-sizes="page.pageSizes" :page-size="page.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
          </el-pagination>
        </footer>
      </div>

      <!-- <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="saveClick" :loading="addLoading" type="primary" style="margin-right: 10px">确定</el-button>
      </span> -->
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="addDialog = false" :loading="addLoading">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Table from "@/components/table/dataTablec";
import { post ,exportExcel} from "@/api/table/table";
export default {
  components: {
    Table,
  },
  data() {
    return {
      page: {
        pageSize: 10,
        total: 0,
        currentPage: 1,
        pages: 0,
      },
      addDialog: false, // 弹出框
      tableData: [],
      OP_CONTENT: "",
      option:{
        addBtn: false,
        refreshBtn: false,
        searchShowBtn: false,
        // menuHeaderAlign: 'center',
        menu: false,
        border: true,
        header: false,
        column:[
          {
            label:'序号',
            prop:'ROW_ID',
            width: '80px',
            headerAlign: 'center',
            align: 'center',
          }, {
            label:'操作时间',
            prop:'CRT_TIME',
            headerAlign: 'center',
            align: 'center',
            overHidden:true,
          }, {
            label:'单位名称',
            prop:'DWMC',
            headerAlign: 'center',
            align: 'center',
            overHidden:true,
          }, {
            label:'单位类别',
            prop:'DWJGLB',
            headerAlign: 'center',
            align: 'center',
          }, {
            label:'创建人',
            prop:'CRT_USERNAME',
            headerAlign: 'center',
            align: 'center',
          }, {
            label:'统一信用代码类型',
            prop:'TYXYDM',
            headerAlign: 'center',
            align: 'center',
            overHidden:true,
          }, {
            label:'统一信用代码',
            prop:'XYDM',
            headerAlign: 'center',
            align: 'center',
            overHidden:true,
          }, {
            label:'状态',
            prop:'STATUS',
            headerAlign: 'center',
            align: 'center',
            // 突出显示
            html:true,
            formatter:(val)=>{
              // console.log(val)
              if (val.STATUS) {
                return val.STATUS == '导入失败' ? '<b style="color:red">'+val.STATUS : val.STATUS
              }
            }
          }, {
            label:'结果',
            prop:'MSG',
            headerAlign: 'center',
            align: 'center',
            width: '220px',
            overHidden:true,
          },
        ]
      },
    };
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  watch: {},
  methods: {
    // 点击详情
    toDetailClick(btn, row) {
      console.log(btn, row);
      this.addDialog = true;
      // let startIndex = row.OP_CONTENT.indexOf("<");
      // const endIndex = row.OP_CONTENT.indexOf(">", startIndex);
      this.page.currentPage = 1;
      // this.OP_CONTENT = row.OP_CONTENT.slice(startIndex + 1, endIndex);
      this.row = row.OP_REASON || "";
      this.content = row.OP_CONTENT
      this.getToDetailClick();
    },
    async getToDetailClick() {
      let res = await post("/api/blade-xfjd/api/dbimp/getImpDetail",{msg: this.content, logId: this.row, query: { current: this.page.currentPage, size: this.page.pageSize }});
      console.log(res,'res-----')
      this.tableData = res.data.data.records
      this.page.total = res.data.data.total
    },

    // 页码
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
      this.getToDetailClick();
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.page.currentPage = 1;
      this.getToDetailClick();
    },
  },
  created() {},
  mounted() {},
  activated() {},
};
</script>

<style lang="scss" scoped>
.ux-page {
  margin-top: 14px;
  // height:32px;
  footer {
    float: right;
  }
}
/deep/.avue-crud__pagination{
  display: none;
}
</style>